export const USER_ROLE = {
    ADMIN: 'admin',
    MODERATOR: 'moderator',
};
export const USER_ROLE_VALUES = Object.values(USER_ROLE);
//# sourceMappingURL=role.js.map